import BaseCart from './base';

class QuickCart extends BaseCart {
  public cart: HTMLElement | null;
  public toggles: NodeList | null;

  constructor() {
    super();

    this.toggleQuickCart = this.toggleQuickCart.bind(this);
  }

  cache() {
    this.cart = document.querySelector('.js-quick-cart');
    this.toggles = document.querySelectorAll('.js-quick-cart-toggle');

    super.cache();
  }

  bindings() {
    if (this.toggles) {
      Object.values(this.toggles).forEach((toggle: Node) => {
        toggle.addEventListener('click', this.toggleQuickCart);
      });
    }

    document.addEventListener('cart:updated', (e: Event) => {
      // @ts-ignore
      if (e.detail.showCart) {
        this.toggleQuickCart(null, true);
      }
    });

    super.bindings();
  }

  toggleQuickCart(e: Event | null, autoHide: boolean = false) {
    if (e) {
      e.preventDefault();
    }

    if (this.cart) {
      if (autoHide) {
        this.cart.classList.add('is--active');

        setTimeout(() => {
          // @ts-ignore
          this.cart.classList.remove('is--active');
        }, 4000);
      } else {
        this.cart.classList.toggle('is--active');
      }
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default QuickCart;
